<div class="sf-comments">
  @if (loading) {
    <p class="sc-note">Loading comments…</p>
  }

  @for (thread of threads; track thread.comment.id) {
    <div class="sc-thread">
      <ng-container *ngTemplateOutlet="row; context: { $implicit: thread.comment, isReply: false }"></ng-container>

      @if (thread.replies.length && !expanded.has(thread.comment.id)) {
        <button type="button" class="sc-toggle sc-show-replies" (click)="toggleReplies(thread.comment.id)">
          View {{ thread.replies.length }} {{ thread.replies.length === 1 ? 'reply' : 'replies' }}
        </button>
      }

      @if (expanded.has(thread.comment.id)) {
        <div class="sc-replies">
          @for (reply of thread.replies; track reply.id) {
            <ng-container *ngTemplateOutlet="row; context: { $implicit: reply, isReply: true }"></ng-container>
          }
          @if (thread.replies.length) {
            <button type="button" class="sc-toggle sc-hide-replies" (click)="toggleReplies(thread.comment.id)">Hide replies</button>
          }

          @if (replyingTo === thread.comment.id) {
            <div class="sc-reply-form">
              <input
                #replyBox
                type="text"
                class="sc-reply-input"
                placeholder="Write a reply…"
                aria-label="Write a reply"
                [(ngModel)]="replyDraft"
                (keyup.enter)="submitReply()"
                (keyup.escape)="cancelReply()" />
              <app-social-emoji-picker [target]="replyBox"></app-social-emoji-picker>
              <button type="button" class="sc-reply-send" [disabled]="sending" (click)="submitReply()">
                {{ sending ? 'Sending…' : 'Reply' }}
              </button>
              <button type="button" class="sc-reply-cancel" (click)="cancelReply()">Cancel</button>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="sf-comment-form">
    <input
      #commentBox
      type="text"
      placeholder="Write a comment…"
      aria-label="Write a comment"
      [(ngModel)]="draft"
      (keyup.enter)="submitComment()" />
    <app-social-emoji-picker [target]="commentBox"></app-social-emoji-picker>
    <button type="button" [disabled]="sending" (click)="submitComment()">
      {{ sending ? 'Sending…' : 'Comment' }}
    </button>
  </div>
  @if (error) {
    <p class="sf-comment-error" role="alert">{{ error }}</p>
  }
</div>

<ng-template #row let-c let-isReply="isReply">
  <div class="sf-comment sc-row" [class.is-pending]="c.pending" [class.is-reply]="isReply" [id]="'comment-' + c.id">
    <span class="sf-comment-body">
      @if (editingId === c.id) {
        <span class="sc-edit">
          <input
            #editBox
            type="text"
            class="sc-edit-input"
            aria-label="Edit your comment"
            [(ngModel)]="editDraft"
            (keyup.enter)="saveEdit(c)"
            (keyup.escape)="cancelEdit()" />
          <app-social-emoji-picker [target]="editBox"></app-social-emoji-picker>
          <button type="button" class="sc-save" [disabled]="!editDraft.trim() || savingEdit" (click)="saveEdit(c)">
            {{ savingEdit ? 'Saving…' : 'Save' }}
          </button>
          <button type="button" class="sc-cancel" (click)="cancelEdit()">Cancel</button>
        </span>
        @if (editError) {
          <span class="sc-edit-error" role="alert">{{ editError }}</span>
        }
      } @else {
        <span class="sf-comment-author">{{ c.author.name }}</span>
        <span class="sf-comment-text">{{ c.content }}</span>
        @if (c.is_edited) {
          <span class="sc-edited">(edited)</span>
        }
        <span class="sc-actions">
          <button
            type="button"
            class="sc-like"
            [class.is-on]="c.liked_by_me"
            [disabled]="c.pending"
            [attr.aria-pressed]="c.liked_by_me"
            [attr.aria-label]="c.liked_by_me ? 'Unlike this comment' : 'Like this comment'"
            (click)="toggleLike(c)">
            <i class="fa" [class.fa-heart]="c.liked_by_me" [class.fa-heart-o]="!c.liked_by_me"></i>
            @if (c.likes_count > 0) {
              <span class="sc-like-count">{{ c.likes_count }}</span>
            }
          </button>
          <button type="button" class="sc-reply" [disabled]="c.pending" (click)="startReply(c)">Reply</button>
          <span class="sc-time">{{ timeAgo(c.created_at) }}</span>
        </span>
      }
    </span>
    <app-social-post-menu
      label="Comment options"
      [canEdit]="c.can_edit === true && editingId !== c.id"
      [canDelete]="c.can_delete === true"
      [canReport]="canReport(c)"
      (edit)="startEdit(c)"
      (remove)="askDelete(c)"
      (report)="askReport(c)"></app-social-post-menu>
  </div>
</ng-template>

<app-social-confirm-dialog
  [open]="pendingDelete !== null"
  title="Delete comment?"
  [message]="deleteMessage"
  [busy]="deleting"
  (confirm)="confirmDelete()"
  (cancel)="cancelDelete()"></app-social-confirm-dialog>

<app-social-report-dialog
  [open]="pendingReport !== null"
  [target]="pendingReport"
  (closed)="closeReport()"></app-social-report-dialog>
